import { useState, useEffect } from "react";
import { buscarAnunciosService } from "../../../services/buscarAnunciosService";
import { buscarUsuarioByIdService } from "../../../services/buscarUsuarioByIdService";
import { Usuario } from "../../../interfaces/Usuario";
import { formatDate } from "../../../uteis/dateUtils";

const obterEmpreendimento = (item: any) =>
  item?.nomeEmpreendimento ??
  item?.empreendimento ??
  item?.CotasUsuariosTable?.CotaTable?.AptoTable?.EmpreendimentoTable?.nome ??
  item?.CotasUsuariosTable?.CotaTable?.EmpreendimentoTable?.nome ??
  "Empreendimento nao informado";

const formatarData = (date: string | Date | null | undefined) =>
  formatDate(date) || "Nao informada";

export const useBuscarAnuncios = () => {
  const [anuncios, setAnuncios] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const buscarUsuario = async (usuarioId: number) => {
    const usuario: Usuario = await buscarUsuarioByIdService(usuarioId);

    return {
      nomeCompleto:
        `${usuario?.nome ?? ""} ${usuario?.sobrenome ?? ""}`.trim() ||
        "Proprietario nao informado",
      celular: usuario?.celular ?? "N/A",
    };
  };

  const buscar = async () => {
    try {
      setIsLoading(true);

      const data = await buscarAnunciosService();
      const anunciosRecebidos = Array.isArray(data) ? data : [];

      console.log("Dados recebidos:", anunciosRecebidos);

      const anuncioFormatado = await Promise.all(
        anunciosRecebidos.map(async (item: any) => {
          const usuarioId = item?.CotasUsuariosTable?.usuarioId;
          const user = usuarioId
            ? await buscarUsuario(usuarioId)
            : {
                nomeCompleto: "Proprietario nao informado",
                celular: "N/A",
              };

          return {
            id: item?.id || "",
            proprietario: user.nomeCompleto,
            celular: user.celular,
            empreendimento: obterEmpreendimento(item),
            dataAnuncio: formatarData(item?.dataAnuncio),
            dataInativacaoAnuncio: formatarData(item?.dataInativacaoAnuncio),
            active: item?.active ? "Sim" : "Não",
          };
        })
      );

      setAnuncios(anuncioFormatado);
    } catch (error) {
      console.error("Erro ao buscar anúncios:", error);
      setAnuncios([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    buscar();
  }, []);

  return { anuncios, isLoading, buscar };
};
